import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex items-center justify-center mb-6">
        <div className="flex items-center justify-center w-16 h-16 bg-primary rounded-xl shadow-soft overflow-hidden">
          <img 
            src="/assets/images/sistema.png" 
            alt="Sistema FINET" 
            className="w-full h-full object-contain"
          />
        </div>
      </div>

      {/* Title and Description */}
      <div className="space-y-2">
        <h1 className="text-3xl font-semibold text-foreground">
          FINET
        </h1>
        <p className="text-lg text-muted-foreground">
          Sistema de Filiação Partidária
        </p>
        <p className="text-sm text-muted-foreground max-w-sm mx-auto">
          Acesso seguro para administradores e equipe gerenciarem dados e operações dos filiados
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;